/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    bold: false,
    id: {
      value: "1",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Giá trị hợp đồng",
      bg: false,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "2",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu chưa bao gồm thuế giá trị gia tăng",
      bg: false,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "3",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu phần việc nhà thầu phụ Việt Nam thực hiện được trừ (nếu có)",
      bg: false,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "4",
      bg: true,
    },
    declaration: {
      value: 0,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Doanh thu tính thuế(4=3-2)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "5",
      bg: false,
    },
    declaration: {
      value: 0,
      bg: false,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Thuế thu nhập doanh nghiệp phải nộp",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "6",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: false,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Số thuế thu nhập doanh nghiệp đã nộp",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "7",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Số thuế thu nhập doanh nghiệp còn phải nộp(7=5-6>=0)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: "8",
      bg: false,
    },
    declaration: {
      value: null,
      bg: true,
    },
    settlement: {
      value: 0,
      bg: true,
    },
    difference: {
      value: null,
      bg: true,
    },
    title: {
      value: "Số thuế thu nhập doanh nghiệp nộp thừa(8=5-6<0)",
      bg: true,
    },
    note: {
      value: null,
      bg: false,
    },
  },
];

export default function TaxPersonalTable({setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
      <Box style={{ maxWidth: "100%", overflowX: "auto" }}>
        <table style={tableStyle}>
          <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Kê khai</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Quyết toán</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Chênh lệch</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Ghi chú
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(1)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(2)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(3)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(4)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(5)=(4)-(3)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(6)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.id.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.id.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.value}
                  </Td>
                  {index <= 5 &&
                  <Td
                  rowSpan= {index == 5 ? "3": "1"}
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.declaration.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.declaration.bg ? (
                      row.declaration.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="declaration"
                        value={row.declaration.value}
                        onChange={handleChange}
                        type="number"

                      />
                    )}
                  </Td>}
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.settlement.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.settlement.bg ? (
                      row.settlement.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="settlement"
                        value={row.settlement.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>
                  {index <= 5 &&
                  <Td
                    rowSpan= {index == 5 ? "3": "1"}
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.difference.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.difference.bg ? (
                      index == 5 ? "" : "0"
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="difference"
                        value={row.difference.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>}
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.note.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.note.bg ? (
                      row.note.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="note"
                        value={row.note.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        </Box>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
